
import { Component, Vue } from 'vue-property-decorator'
import { ServerState } from 'shared/state'
import { config, GlobalConfig } from 'display/config'
import { version } from '../../package.json'
import SelectControl from 'display/components/controls/Select.vue'
import { Languages } from 'shared/services/languages'

@Component({ components: { SelectControl } })
export default class HomePage extends Vue {
  @GlobalConfig() lang!: string
  version = version

  get langs(): string[] {
    return Languages.list
  }

  langChange(lang: string) {
    config.set({ global: { lang } })
    Vue.loadLang(lang)
  }

  get host() {
    return document.location.host
  }
}
